<template>
  <el-dialog
    title="提示"
    :center="true"
    :visible.sync="dialogVisible"
    width="515px"
    class="reset-pass-dialog"
    @close="handleClose"
  >
    <img class="img" v-if="showWechatWorkQrCode" :src="wechatWorkQrCode" />
    <p v-else>{{ interceptText }}</p>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleOk()">{{
        wechatWorkQrCode && !showWechatWorkQrCode ? '联系老师' : '我知道了'
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ContactTeacherDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    interceptText: {
      type: String,
      default: '',
    },
    wechatWorkQrCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialogVisible: false,
      showWechatWorkQrCode: false,
    };
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal;
    },
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleOk() {
      if (this.wechatWorkQrCode && !this.showWechatWorkQrCode) {
        this.showWechatWorkQrCode = true;
        return;
      }
      this.showWechatWorkQrCode = false;
      this.handleClose();
    },
  },
};
</script>

<style scoped lang="scss">
.img {
  width: 200px;
  height: 200px;
  display: block;
  margin: auto;
}
</style>
